import Button from "components/Button";
import Modal from "components/Modal";
import ModalFooter from "components/ModalFooter";
import { useMemo } from "react";
import { DocumentFolderType } from "services/types";
import { sortDocumentFoldersByRootFolder } from "utils/documents";

interface ConfirmSendAnswerModalProps {
	isModalOpen: boolean;
	setIsModalOpen: (newValue: boolean) => void;
	primaryAction: () => void;
	selectedDocumentFolders: DocumentFolderType[];
}

export default function ConfirmSendAnswerModal({
	isModalOpen,
	setIsModalOpen,
	primaryAction,
	selectedDocumentFolders
}: Readonly<ConfirmSendAnswerModalProps>): JSX.Element {
	const documentFoldersByRootFolder = useMemo(() => {
		return sortDocumentFoldersByRootFolder(selectedDocumentFolders, true) as {
			folders: DocumentFolderType[];
			label: string;
		}[];
	}, [selectedDocumentFolders]);

	return (
		<Modal
			isOpen={isModalOpen}
			onClose={() => setIsModalOpen(false)}
			contentClassName="rounded-lg md:max-w-xl"
			bodyClassName="p-8"
		>
			<div className="flex flex-col gap-7">
				<h1 className="text-2xl font-semibold">Deseja continuar?</h1>
				<p className="text-neutral-low-400 text-justify">
					Você está atualizando uma pasta completa de documentos. Ao continuar,
					os arquivos enviados anteriormente serão superados pelas novas
					versões. Portanto, será necessário reenviar o conjunto completo de
					documentos dessa pasta para evitar inconsistências no envio e
					possíveis devolutivas futuras por ausência de documentos.
				</p>
			</div>
			<div className="flex flex-col gap-2 max-h-[30vh] overflow-y-auto">
				<p className="text-xs text-transform--uppercase text-neutral-low-pure-500">
					Pastas selecionadas:
				</p>
				{documentFoldersByRootFolder.map((rootFolder, rootFolderIndex) => {
					return rootFolder.folders.length > 0 ? (
						<div key={rootFolderIndex}>
							<div className="text-transform--uppercase text-xs text-caption-default py-2">
								{rootFolder.label}
							</div>
							<ul style={{ listStyleType: "square" }} className="list-inside">
								{rootFolder.folders.map((documentFolder, index) => (
									<li key={index}>{documentFolder.documentType.name}</li>
								))}
							</ul>
						</div>
					) : (
						<div key={rootFolderIndex} />
					);
				})}
			</div>
			<ModalFooter>
				<div className="w-full h-full flex md:flex-row gap-4 flex-col items-stretch justify-end">
					<Button hierarchy="secondary" onClick={() => setIsModalOpen(false)}>
						Fechar
					</Button>
					<Button hierarchy="primary" onClick={() => primaryAction()}>
						Anexar arquivo
					</Button>
				</div>
			</ModalFooter>
		</Modal>
	);
}
